// Toggle slide height of element on click
function collapsibleToggle() {
  let this_block = this.closest(".collapsible-block"); // Get parent container

  // Close other active sibling accordions
  const siblingContent = this_block.parentNode.querySelectorAll(
    ".collapsible-block"
  );
  for (let i = 0; i < siblingContent.length; i++) {
    if (
      !siblingContent[i].classList.contains("closed") &&
      siblingContent[i] !== this_block
    ) {
      siblingContent[i].classList.add("closed");
    }
  }

  let content = this_block.querySelector(".collapsible-content"); // The content to toggle
  let height = this_block.dataset.height; // Get saved height

  if (this_block.classList.contains("closed")) {
    this_block.classList.remove("closed");
    if (!this_block.classList.contains("accordion")) {
      content.style.height = height + "px";
    }
  } else {
    this_block.classList.add("closed");
    content.style.height = "";
  }
}

export function collapsibleInit() {
  let blocks = document.querySelectorAll(".collapsible-block");

  for (let i = 0; i < blocks.length; i++) {
    // Set the height of the content to whatever 'auto' renders it as
    let content = blocks[i].querySelector(".collapsible-content");
    if (content !== null) {
      content.style.height = "auto"; // Set to auto
      blocks[i].dataset.height = content.offsetHeight; // Save height
      content.style.height = content.offsetHeight + "px"; // Set explicitly
    }

    // Add the event listener to the header
    let header = blocks[i].querySelector(".collapsible-header");
    if (header !== null) {
      header.addEventListener("click", collapsibleToggle);
    }

    // Set to closed initially - all except the first unless the block is part of the block-accordion module
    if (i !== 0 || blocks[i].classList.contains("accordion")) {
      blocks[i].classList.add("closed");
      content.style.height = "";
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/collapsible.js